<template>
  <v-col cols="2">
    <v-card class="align-start metrics-card-top">
      <v-card-title class="d-flex justify-space-between">
        <div class="hidden-element">Hidden</div>
        <!--Hidden element to allow center and right align of label and icon-->
        <label class="font-weight-bold text-decoration-underline">Service Status</label>
        <tooltip>
          <p>
            Check the last active chatbot engagement date and whether the code has been seen on the website within the
            last hour
          </p>
        </tooltip>
      </v-card-title>
      <v-card-text class="d-flex flex-column justify-space-around metrics-card-text">
        <StatsValue :loading="loading" title="Last active chatbot engagement">{{ lastEngagement }}</StatsValue>
        <StatsValue :loading="loading" title="Code working in the last 24 hours">
          <span :class="{'status-code-green': codeRunning, 'status-code-red': !codeRunning}">
            {{ codeRunning }}
          </span>
        </StatsValue>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import StatsValue from "@/components/HealthScore/StatsValue.vue";
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import Tooltip from "@/components/HealthScore/Tooltip.vue";
import moment from "moment";

export default {
  name: 'ServiceStatus',
  components: {Tooltip, StatsValue},
  computed: {
    ...mapState('healthScoreStore', ['chatOverview']),
    loading() {
      return this.chatOverview.state === LoadingState.LOADING;
    },
    lastEngagement() {
      const engagements = this.chatOverview.data.find((element) => element.EVENT_NAME === 'chat_opened');
      return engagements ? moment(engagements.LATEST_EVENT).format('YYYY-MM-DD HH:mm') : 'unknown';
    },
    lastChatEvent() {
      return this.chatOverview.data.find((element) => element.EVENT_NAME === 'chat_icon_shown');
    },
    codeRunning() {
      if (this.lastChatEvent) {
        let isLastEventInPast24H = moment(this.lastChatEvent.LATEST_EVENT).isAfter(moment().subtract(1, 'day'));
        if (isLastEventInPast24H) {
          return true;
        }
      }
      return false;
    },
  },
}
</script>

<style lang="scss">
.status-code-red {
  color: var(--v-error-darken2);
}

.status-code-green {
  color: var(--v-primary-darken2);
}

</style>
